<template>
    <div>
      <el-dialog
        title="学生信息详情"
        :visible.sync="dialogVisible"
        @close="$emit('setzero')"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <table
              class="
                myTable
                el-table
                el-table--fit
                el-table--striped
                el-table--border
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
              style="width: 100%"
            >
              <tr>
                <td>姓名：{{ info.realName }}</td>
                <td>性别：{{ info.sex ? "男" : "女" }}</td>
              </tr>
              <tr>
                <td>添加时间：{{ info.inputTime ? String(info.inputTime).substring(0, 10) : '' }}</td>
                <td>营销老师：{{ info.marketName||'' }}</td>
              </tr>
              <tr>
                <td>跟进状态：{{ info.state != null && info.state !== '' ? info.state : '' }}</td>
                <td>学生/家长：{{ info.studentType || '' }}</td>
              </tr>
              <tr>
                <td>来源：{{ info.origin || '' }} {{ info.originRemark || '' }} {{ info.recName || '' }}</td>
                <td>计划赴日：{{ info.abroadPlan || '' }}</td>
              </tr>
              <tr>
                <td>留学时间：{{ info.abroadDate || '' }}</td>
                <td>学历：{{ info.eduBack || '' }}</td>
              </tr>
              <tr>
                <td>微信：{{ info.wechat || '' }}</td>
                <td>QQ：{{ info.qq != null && info.qq !== '' ? info.qq : '' }}</td>
              </tr>
              <tr>
                <td>电话：{{ info.mobile || '' }}</td>
                <td>地区：{{ (info.zzProvinceName || '') + (info.zzCityName || '') }}</td>
              </tr>
              <tr>
                <td>意向课程：{{ info.intendedCourse || '' }}</td>
                <!-- <td>地区：{{ (info.zzProvinceName || '') + (info.zzCityName || '') }}</td> -->
              </tr>
              <tr>
                <!-- <td>日语等级：{{ info.japaneseBase || '' }}</td> -->
                <td>日语：{{ info.japanese || '' }}</td>
                <td>英语：{{ info.english || '' }}</td>
              </tr>
              <tr>
                <td>文理：{{ info.artsScience || '' }}</td>
                <td>专业：{{ info.major||'' }}</td>
              </tr>
              <tr>
                <td>缴费时间：{{ info.paymentDate || '' }}</td>
                <td>缴费金额：{{ info.paymentAmount||'' }}</td>
              </tr>
              <tr>
                <td>赴日时间：{{ info.abroadDate || '' }}</td>
                <td>语言学校：{{ info.languageSchool||'' }}</td>
              </tr>
              <tr>
                <td>学习课程：{{ info.courseName || '' }}</td>
                <td></td>
              </tr>
              <tr>
                <td>开课时间：{{ info.startTime || '' }}</td>
                <td>结课时间：{{ info.endTime||'' }}</td>
              </tr>
              <tr>
                <td>出身校：{{ info.schoolName || '' }}</td>
               
              </tr>
              <tr>
                <td>留考成绩：{{ info.examScore || '' }}</td>
                <td>合格时间：{{ info.qualifiedTime || '' }}</td>
              </tr>
              <tr>
                <td>合格学校和专业：{{ info.qualifiedSchools || '' }}</td>
                <td>入学学校：{{ info.enrolledSchool || '' }}</td>
              </tr>
              <tr>
                <td>入学专业：{{ info.enrolledMajor || '' }}</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="2">跟进情况：{{ info.followSummary || '' }}</td>
              </tr>
              <tr v-if="info.state === 'e' && info.reason">
                <td colspan="2">淘汰原因：{{ info.reason }}</td>
              </tr>
         
              <tr >
                <td>鸣野顾问：{{ info.myAdviserName || '' }}</td>
                <td>鸣野营销：{{ info.myMarketName || '' }}</td>
              </tr>
              <tr >
                <td>升学阶段：{{ info.stage === 2 ? '升学时' : '赴日前' }}</td>
                <td></td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane label="详细信息" name="second">
            <table
              class="
                myTable
                el-table
                el-table--fit
                el-table--striped
                el-table--border
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
              style="width: 100%"
            >
              <tr>
                <td>留学时间：{{ info.abroadDate }}</td>
                <td>申请学校：{{ info.applySchool }}</td>
              </tr>
              <tr>
                <td>民族：{{ info.nation }}</td>
                <td>出生日期：{{ info.birthday }}</td>
              </tr>
              <tr>
                <td>赴日历史：{{ info.japanHistory }}</td>
                <td v-if="info.hjProvinceName">户籍：{{ info.hjProvinceName + " " + info.hjCityName }}</td>
              </tr>
              <tr>
                <td>高考成绩：{{ info.gaoKaoScore }}</td>
                <td>会考成绩：{{ info.huiKaoScore }}</td>
              </tr>
              <tr>
                <td v-if="info.zzProvinceName">
                  家庭住址：{{
                    info.zzProvinceName + " " + info.zzCityName + " "
                  }}
                  <div>{{ info.zzDetail }}</div>
                </td>
                <td v-if="info.provinceName">
                  现住住址：{{ info.provinceName + " " + info.cityName + " " }}
                  <div>{{ info.siteDetail }}</div>
                </td>
              </tr>
              <tr>
                <td>学历：{{ info.eduBack }}</td>
                <td>电话：{{ info.mobile }}</td>
              </tr>
              <tr>
                <td>QQ：{{ info.qq }}</td>
                <td>邮箱：{{ info.email }}</td>
              </tr>
              <tr>
                <td>赴日目的：{{ info.purpose }}</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-divider content-position="left" style>日语能力</el-divider>
                </td>
              </tr>
              <tr>
                <td>日语情况：{{ info.japanese }}</td>
                <td>
                  <!-- JTest考试：{{info.jtest}} -->
                </td>
              </tr>
              <tr>
                <td>学习机构：{{ info.learningInstituion }}</td>
                <td>
                  学习时间：{{ info.lastExamStartDate }}-{{
                    info.lastExamEndDate
                  }}
                </td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane label="学历/职历/家庭" name="three">
            <!-- 学历 -->
            <el-divider content-position="left" style>学历</el-divider>
            <el-table
              v-loading="loading"
              :data="info.eduList"
              stripe
              border
              style="width: 100%"
            >
              <el-table-column prop="name" label="学历名称"></el-table-column>
              <el-table-column prop="school" label="学校名称"></el-table-column>
              <el-table-column
                prop="startDate"
                label="开始时间"
              ></el-table-column>
              <el-table-column prop="endDate" label="结束时间"></el-table-column>
              <el-table-column prop="xueZhi" label="学制"></el-table-column>
              <el-table-column prop="special" label="专业"></el-table-column>
            </el-table>
            <!-- 职历 -->
            <el-divider content-position="left" style>职历</el-divider>
            <el-table
              v-loading="loading"
              :data="info.postList"
              stripe
              border
              style="width: 100%"
            >
              <el-table-column prop="company" label="单位名称"></el-table-column>
              <el-table-column prop="post" label="职位名称"></el-table-column>
              <el-table-column
                prop="startDate"
                label="开始时间"
              ></el-table-column>
              <el-table-column prop="endDate" label="结束时间"></el-table-column>
            </el-table>
  
            <!-- 家庭成员 -->
            <el-divider content-position="left" style>家庭成员</el-divider>
            <el-table
              v-loading="loading"
              :data="info.familyList"
              stripe
              border
              style="width: 100%"
            >
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="relation" label="关系"></el-table-column>
              <el-table-column
                prop="post"
                label="单位和职位名称"
              ></el-table-column>
              <el-table-column prop="income" label="收入"></el-table-column>
              <el-table-column prop="mobile" label="电话"></el-table-column>
            </el-table>
          </el-tab-pane>
  
          <el-tab-pane label="希望的大学" name="fourth" v-if="info.graApplySchool">
            <!-- 学历 -->
            <el-divider content-position="left" style>日本大学</el-divider>
            <el-table
              v-loading="loading"
              :data="info.graApplySchool"
              stripe
              border
              style="width: 100%"
            >
              <el-table-column prop="school" label="学校名称"></el-table-column>
              <el-table-column prop="special" label="专业名字"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
  
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import url from "@/plugins/urlHelper.js";
  import user from "@/plugins/user.js";
  //学生信息展示
  export default {
    props: ["stuid"],
    data() {
      return {
        info: {}, //用户基本信息
        dialogVisible: false,
        activeName: "first",
        loading: false,
      };
    },
    watch: {
      stuid: function (newVal, oldVal) {
        console.log(newVal);
        
        var _this = this;
        _this.activeName = 'first';
        if (newVal > 0) {
            var link = url.getStu("GetModelDetail");
          var linkMingye = url.getMingye("getmodel_base");
          $.get(link, { id: newVal }, (res) => {
            if (res && typeof res.graApplySchool === 'string' && res.graApplySchool) {
                res.graApplySchool = JSON.parse(res.graApplySchool);
            }
            // _this.info = res || {};
            $.get(linkMingye, { studentID: newVal }, (myData) => {
          var s = res || {};
          var m = myData || {};
          var norm = function (obj, a, b) {
            return obj[a] != null ? obj[a] : (obj[b] != null ? obj[b] : null);
          };
          _this.info = {
            id: norm(s, "id", "ID"),
            studentID: newVal,
            inputTime: norm(s, "inputTime", "InputTime"),
            realName: norm(s, "realName", "RealName"),
            sex: s.sex != null ? s.sex : s.Sex,
            state: norm(s, "state", "State"),
            eduBack: norm(m, "eduBack", "EduBack") != null ? norm(m, "eduBack", "EduBack") : norm(s, "eduBack", "EduBack"),
            wechat: norm(s, "wechat", "Wechat"),
            qq: norm(s, "qq", "QQ"),
            mobile: norm(s, "mobile", "Mobile"),
            origin: norm(s, "origin", "Origin"),
            recName: norm(s, "recName", "RecName"),
            zzProvinceName: norm(s, "zzProvinceName", "ZZProvinceName"),
            zzCityName: norm(s, "zzCityName", "ZZCityName"),
            myMarketID: s.myMarketID != null ? s.myMarketID : s.MyMarketID,
            myAdviserID: s.myAdviserID != null ? s.myAdviserID : s.MyAdviserID,
            marketID: s.marketID != null ? s.marketID : s.MarketID,
            adviserID: s.adviserID != null ? s.adviserID : s.AdviserID,
            followSummary: norm(s, "followSummary", "FollowSummary"),
            isMingye: true,
            isStudent: s.isStudent != null ? s.isStudent : s.IsStudent,
            isJap: s.isJap != null ? s.isJap : s.IsJap,
            exitAmount: s.exitAmount != null ? s.exitAmount : s.ExitAmount,
            reason: norm(s, "reason", "Reason"),
            intendedCourse: norm(m, "intendedCourse", "IntendedCourse"),
            studentType: norm(m, "studentType", "StudentType"),
            paymentDate: norm(m, "paymentDate", "PaymentDate"),
            paymentAmount: norm(m, "paymentAmount", "PaymentAmount") != null ? norm(m, "paymentAmount", "PaymentAmount") : 0,
            abroadDate: norm(m, "abroadDate", "AbroadDate"),
            languageSchool: norm(m, "languageSchool", "LanguageSchool"),
            courseName: norm(m, "courseName", "CourseName"),
            startTime: norm(m, "startTime", "StartTime"),
            endTime: norm(m, "endTime", "EndTime"),
            stage: m.stage != null ? m.stage : (m.Stage != null ? m.Stage : 1),
            schoolName: norm(m, "schoolName", "SchoolName"),
            japanese: norm(m, "japanese", "Japanese") != null ? norm(m, "japanese", "Japanese") : norm(s, "japaneseBase", "JapaneseBase"),
            english: norm(m, "english", "English"),
            examScore: norm(m, "examScore", "ExamScore"),
            major: norm(m, "major", "Major"),
            artsScience: norm(m, "artsScience", "ArtsScience"),
            qualifiedTime: norm(m, "qualifiedTime", "QualifiedTime"),
            qualifiedSchools: norm(m, "qualifiedSchools", "QualifiedSchools"),
            enrolledSchool: norm(m, "enrolledSchool", "EnrolledSchool"),
            enrolledMajor: norm(m, "enrolledMajor", "EnrolledMajor"),
            feel: norm(m, "feel", "Feel"),
            book: norm(m, "book", "Book"),
            imgList: norm(m, "imgList", "ImgList"),
          };
          _this.selectedOptions = [];
          if (_this.info.zzProvinceName) _this.selectedOptions.push(_this.info.zzProvinceName);
          if (_this.info.zzCityName) _this.selectedOptions.push(_this.info.zzCityName);
          ["inputTime", "paymentDate", "abroadDate", "startTime", "endTime", "qualifiedTime"].forEach(function (key) {
            var val = _this.info[key];
            if (val && typeof val === "string" && val.length > 10) _this.info[key] = val.substring(0, 10);
          });
          _this.dialogVisible = true;
        });
          });
        }
      },
    },
  };
  </script>
  
  
  <style scoped>
  .myTable td {
    text-indent: 10px;
  }
  .myTable tr td:last-child {
    border-right: 0px;
  }
  .myTable tr:last-child td {
    border-bottom: 0px;
  }
  </style>
  